"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInjectedConnector = void 0;
var react_1 = require("react");
var use_contractkit_1 = require("../use-contractkit");
var connectors_1 = require("./connectors");
function useInjectedConnector(onSubmit, isMetaMask) {
    var _this = this;
    var _a = (0, use_contractkit_1.useContractKitInternal)(), network = _a.network, feeCurrency = _a.feeCurrency, initConnector = _a.initConnector, error = _a.initError, dapp = _a.dapp, kit = _a.kit;
    (0, react_1.useEffect)(function () {
        var stale;
        void (function () { return __awaiter(_this, void 0, void 0, function () {
            var connector, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        connector = isMetaMask
                            ? new connectors_1.MetaMaskConnector(network, feeCurrency)
                            : new connectors_1.InjectedConnector(network, feeCurrency);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, initConnector(connector)];
                    case 2:
                        _a.sent();
                        if (!stale) {
                            onSubmit(connector);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            stale = true;
        };
    }, [initConnector, network, onSubmit, isMetaMask, feeCurrency]);
    var getTokens = (0, react_1.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, kit.celoTokens.getWrappers()];
        });
    }); }, [kit]);
    return { error: error, dapp: dapp, network: network, getTokens: getTokens };
}
exports.useInjectedConnector = useInjectedConnector;
//# sourceMappingURL=useMetaMaskConnector.js.map